import React, { useState, useEffect } from 'react';

const Story2 = () => {

  return (
    <div className="story-container">
      <p className="story-header">But I also knew there was a better way to make museums accessible.</p>
      <p className="story-text">In 2023, I took a step back to re-focus my career in technology with the long-term goal of continuing to support cultural education.</p>
    </div>
  )
}

export default Story2;